module.exports = __webpack_public_path__ + "static/img/logo34.41ce4e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo34.png
// module id = qJWZ
// module chunks = 1